<div class="card csc-login-card mt-5 mx-auto" style="max-width: 800px;">
  <div class="alert alert-info inactivity-message" role="alert" *ngIf="forgotPassword">
    Further instructions have been sent to your e-mail address
  </div>
  <div class="card-inner card-inner-lg px-3 py-4">
    <div class="pb-2 text-center">
      <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
    </div>
    <div class="nk-block-head" *ngIf="!token">
      <div class="nk-block-head-content">
        <h5 class="nk-block-title">Reset password</h5>
        <div class="nk-block-des">
          <p>If you forgot your password, well, then we’ll email you instructions to reset your password.</p>
        </div>
      </div>
    </div>
    <form #forgotPassword="ngForm" (ngSubmit)="requestNewPassword()" *ngIf="!token; else newPassword">
      <div class="form-group">
        <div class="form-label-group">
          <label class="form-label" for="email">Email</label>
        </div>
        <div class="form-control-wrap">
          <input type="text" [disabled]="isSendingForm" [(ngModel)]="username" name="username"
                 class="form-control form-control-lg" id="email" #userName="ngModel"
                 validateEmail="username" required placeholder="Enter your email address">
        </div>
        <small [hidden]="userName.valid || userName.pristine || isSendingForm" class="incorrect-field">
          Valid email is required
        </small>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-lg btn-primary btn-block btn-csc-primary"
                [disabled]="!forgotPassword.form.valid">Send Reset Link
        </button>
      </div>
    </form>
    <div class="form-note-s2 text-center pt-4">
      <a routerLink='/login' class="forgot-password"><strong>Return to login</strong></a>
    </div>
  </div>
</div>

<ng-template #newPassword>
  <div class="card-inner d-flex justify-content-center px-3 py-4">
    <form #resetPassword="ngForm" class="col-12 col-md-10 col-lg-8 mx-auto new-password-form" (ngSubmit)="sendNewPassword()">
      <h1 class="form-title text-center">{{ 'Change Password' | translate }}</h1>
      <p class="explanation text-center">{{ 'Please enter your new password and click the Reset button.' | translate }}</p>
      <div class="form-group">
        <label for="name">{{ 'New Password' | translate }}</label>
        <input [disabled]="isSendingForm" type="password" [(ngModel)]="resetForm.password" name="resetForm.password"
               (ngModelChange)="resetForm.confirmPassword = ''"
               class="form-control" id="resetForm.password" #password="ngModel"
               validateEqual="resetForm.confirmPassword" required
               reverse="true" validatePassword="resetForm.password">
        <small [hidden]="password.valid || password.pristine || isSendingForm" class="incorrect-field">
          {{ 'Password is invalid' | translate }}
        </small>
      </div>
      <div [hidden]="!invalidPasswordRules" class="password-rules">
        <ul>
          <li [ngClass]="checkPasswordError(password.errors, rule.id)"
              *ngFor="let rule of passwordRules">{{ rule.description }}
          </li>
        </ul>
      </div>
      <div class="form-group">
        <label for="name">{{ 'Confirm New Password' | translate }}</label>
        <input [disabled]="isSendingForm" type="password" [(ngModel)]="resetForm.confirmPassword"
               name="resetForm.confirmPassword"
               class="form-control" id="resetForm.confirmPassword" #confirmPassword="ngModel"
               validateEqual="resetForm.password"
               required>
        <small [hidden]="confirmPassword.valid || confirmPassword.pristine || isSendingForm" class="incorrect-field">
          {{ 'Password mismatch' | translate }}
        </small>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-outline-info submit btn-block" [disabled]="!resetPassword.form.valid">
          {{ 'Reset' | translate }}
        </button>
      </div>
      <div class="form-group">
        <button type="button" class="btn btn-outline-info btn-block" (click)="goBack()">
          {{ 'Back' | translate }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
